import { FC } from 'react';

import { keys, pick } from 'lodash';

import { Info } from '@src/ui/components/Info';

import { AuthErrorMessage } from '../AuthErrorMessage/AuthErrorMessage';

const FormError: FC<{ touched?: {}; fieldErrors?: {}; otherErrors?: {} }> = (
    props,
) => {
    const touchedErrors = pick(
        props.fieldErrors || [],
        Object.keys(props.touched || {}),
    );
    const errors = { ...touchedErrors, ...props.otherErrors };
    const errorKeys = keys(errors);
    const hasError = errorKeys.length > 0;

    if (!hasError) {
        return null;
    }

    return (
        <Info type={'error'} className={'mb-6'}>
            {errorKeys.map((error: any, ind: number) => {
                return (
                    <AuthErrorMessage
                        key={`error_${ind}`}
                        error={(errors as any)[error]}
                    />
                );
            })}
        </Info>
    );
};

export default FormError;
